import * as React from "react"
import { useRef } from "react"
import "./product-carousel.scss"

export default function ProductImageSlider({ productImageList }) {
    const sliderRef = useRef(null);

    return (
        <div className={`product-image-slider ${productImageList.length === 1 ? 'single-image-container' : ''}`}
             style={{position: "relative"}}
        >
            {productImageList.length === 1 ? (
                <div className="single-image-wrapper">
                    <div className="blurred-bg"></div>

                    <div className="uk-position-relative" style={{zIndex: 2}}>
                        <div className="uk-flex uk-flex-center uk-flex-middle" style={{minHeight: "352px"}}>
                            <div className={`uk-card uk-card-default`}
                                 style={{background: "transparent", boxShadow: "none"}}>
                                <div className="uk-card-media-top">
                                    <div className={`carousel-image-wrapper active`}>
                                        <img src={productImageList[0]} alt="Product image"
                                             style={{
                                                 height: "352px",
                                                 width: "auto",
                                                 objectFit: "contain"
                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div
                        ref={sliderRef}
                        className="uk-slider-container product-image-swiper"
                        uk-slider="autoplay: false; finite: true; velocity: 1"
                    >
                        <div className="uk-position-relative uk-visible-toggle" tabIndex="-1"
                             style={{minHeight: "352px"}}>
                            <ul className="uk-slider-items uk-child-width-1-1 uk-grid">
                                {productImageList?.map((imageItem, index) => (
                                    <li key={`image-${index}`}>
                                        <div className={`uk-card uk-card-default`}>
                                            <div className="uk-card-media-top">
                                                <div className={`carousel-image-wrapper`}>
                                                    <img src={imageItem} alt={`Product image ${index + 1}`} style={{
                                                        height: "352px",
                                                        width: "auto",
                                                        objectFit: "contain"
                                                    }}/>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
